import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { OnlineSchedulingParams } from 'interfaces/onlineSchedulingParams';

export interface RequestScheduleOverTimeDetail {
  date: string;
  firstInLinks: number;
  googleBookOnline: number;
  others: number;
  totalRequests: number;
}

export interface RoiRequestScheduleOverTimeData {
  periodData: {
    requestsSchedule: RequestScheduleOverTimeDetail[];
    period: {
      startDate: string;
      endDate: string;
    };
  };
}

const useRoiRequestScheduleOverTime = (params: OnlineSchedulingParams) => {
  const storedId = loadSelectedClinicId();
  const clinicIds = params.clinicIds ?? [storedId];
  const headerClinicId = storedId || clinicIds[0];
  const query =
    params.startDate && params.endDate
      ? new URLSearchParams({
          startDate: params.startDate,
          endDate: params.endDate,
          hourType: params.hourType,
        }).toString()
      : '';

  const url =
    params.startDate && params.endDate
      ? `/rois/requests-schedule-over-time?${query}`
      : null;

  const { data, error, isValidating, mutate } = useSWR(
    url && headerClinicId ? [url, clinicIds] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<RoiRequestScheduleOverTimeData>(
        url,
        {
          params: { clinicIds },
          headers: { 'X-ClinicId': headerClinicId },
        }
      );
      return response.data;
    }
  );

  if (!params.startDate || !params.endDate) {
    return {
      data: null,
      error: undefined,
      isLoading: false,
      isValidating: false,
      mutate: async () => {},
    };
  }

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  };
};

export default useRoiRequestScheduleOverTime;
